import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import { Input, Icon } from "@abb/abb-common-ux-react";

import SubmitHeader from "../shared/SubmitHeader";

import IInstrumentTypeFormData from "../../models/instrumentType/InstrumentTypeFormData";
import TableComponent from "../shared/TableComponent";
import IFormComponent from "../../models/shared/FormComponent";

import * as CONSTANTS from "../../utilities/Constants";
import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import tableFormatter from "../shared/TableFormatter";
import submitHeaderActions from "../../flux/actions/SubmitHeaderActions";

import history from "../../utilities/History";
import propertyActions from "../../flux/actions/PropertyActions";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import instrumentTypeActions from "../../flux/actions/InstrumentTypeActions";
import triggerNotifications from "../../utilities/TriggerNotifications";
import instrumentTypeFormStore from "../../flux/stores/instrumentType/FormStore";
import AbbTableComponent from "../shared/AbbTableComponent";
import { Translation } from "react-i18next";

// Todo: Understand
type PropsType = RouteComponentProps & {};
// End

class Form
  extends React.Component<PropsType, IInstrumentTypeFormData>
  implements IFormComponent
{
  _mount: boolean;
  _columns: IColumnHeaderData[];
  _isReload: boolean;
  _id: string;
  _messages: string[];
  _oldData: IInstrumentTypeFormData;

  constructor(props: PropsType) {
    super(props);

    const pushStateData = this.props.location.state as IInstrumentTypeFormData;
    this.state = {
      ...pushStateData,
      formLoading: false,
      nameError: false,
    };
    this._mount = false;
    this._oldData = { ...pushStateData };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    if (this.state.isEditMode) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_INSTRUMENTTYPE,
          isSubmitDisabled: false,
        })
        .then();
    }

    navigationHeaderActions
      .updateHeader({
        name: CONSTANTS.MODULE_INSTRUMENTTYPE,
        action: this.state.isEditMode ? CONSTANTS.EDIT : CONSTANTS.CREATE,
        icon: this.state.isEditMode
          ? ICONCONSTANTS.ABB_EDIT
          : ICONCONSTANTS.ABB_PLUS,
        goBackUrl: CONSTANTS.INSTRUMENTTYPE_INDEX_URL,
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      })
      .then();

    instrumentTypeFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isReload = false;
        this._id = state.id;
        this._messages = state.message;
      }
    });

    this.validate();
  }

  componentDidUpdate() {
    if (JSON.stringify(this._oldData) !== JSON.stringify(this.state)) {
      navigationHeaderActions
        .updateHeader({
          name: CONSTANTS.MODULE_INSTRUMENTTYPE,
          action: this.state.isEditMode ? CONSTANTS.EDIT : CONSTANTS.CREATE,
          icon: this.state.isEditMode
            ? ICONCONSTANTS.ABB_EDIT
            : ICONCONSTANTS.ABB_PLUS,
          goBackUrl: CONSTANTS.INSTRUMENTTYPE_INDEX_URL,
          isGoBackWithData: false,
          goBackData: {},
          isDataChanged: true,
        })
        .then();
    }
  }

  validate(): void {
    if (
      !this.state.nameError &&
      this.state.name !== "" &&
      this.state.properties?.length > 0
    ) {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_INSTRUMENTTYPE,
          isSubmitDisabled: false,
        })
        .then();
    } else {
      submitHeaderActions
        .update({
          moduleName: CONSTANTS.MODULE_INSTRUMENTTYPE,
          isSubmitDisabled: true,
        })
        .then();
    }
  }

  public deleteProperty = (data: any, rowIndex: number) => {
    const filterData = this.state.properties.filter(
      (item) => item.id !== data.id
    );

    this.setState(
      {
        properties: filterData,
      },
      this.validate
    );
  };

  public onSaveClick = () => {
    const tempName = this.state.name.replace(/ +(?= )/g, "").trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        name: tempName,
      }),
      () => {
        instrumentTypeActions
          .put(this.state)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  history.push(CONSTANTS.INSTRUMENTTYPE_INDEX_URL, {
                    isReloadFirst: this._isReload,
                    id: this._id,
                  });
                }, CONSTANTS.NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  public onCreateClick = () => {
    const tempName = this.state.name.replace(/ +(?= )/g, "").trim();
    this.setState(
      (prevState) => ({
        formLoading: true,
        name: tempName,
      }),
      () => {
        instrumentTypeActions
          .post(this.state)
          .then(() => {
            this.setState(
              {
                formLoading: false,
              },
              () => {
                triggerNotifications.success(this._messages);
                setTimeout(() => {
                  history.push(CONSTANTS.INSTRUMENTTYPE_INDEX_URL, {
                    isReloadFirst: this._isReload,
                    id: this._id,
                  });
                }, CONSTANTS.NOTIFICATION_TIMEOUT);
              }
            );
          })
          .catch((error) => {
            this.setState(
              {
                formLoading: false,
              },
              () =>
                triggerNotifications.errors(error.message, error.data).then()
            );
          });
      }
    );
  };

  private setName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    var rgFile = CONSTANTS.COMMONREGEXP;
    if (
      value.trim() &&
      !rgFile.test(value)
    ) {
      this.setState(
        {
          nameError: false,
          name: val,
        },
        this.validate
      );
    } else {
      this.setState(
        {
          nameError: true,
          name: val,
        },
        this.validate
      );
    }
  };

  private nameValidator = (value: string) => {
    return value === ""
      ? { valid: false, text: value }
      : { valid: true, text: value };
  };

  private setDescription = (value: string) => {
    this.setState(
      {
        description: value,
      },
      this.validate
    );
  };

  private associationAction = () => {
    navigationHeaderActions
      .updateHeader({
        name: CONSTANTS.MODULE_PROPERTY,
        action: CONSTANTS.ASSOCIATE,
        icon: ICONCONSTANTS.ABB_PLUS,
        goBackUrl: CONSTANTS.INSTRUMENTTYPE_CREATE_URL,
        isGoBackWithData: true,
        goBackData: this.state,
      })
      .then();
    history.push(CONSTANTS.INSTRUMENTTYPE_ASSOCIATE_PROPERTY_URL, this.state);
  };

  onCancelClick = () => {
    history.push(CONSTANTS.INSTRUMENTTYPE_INDEX_URL, {
      isReloadFirst: this._isReload,
      id: this._id,
    });
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-scroll">
            <div className="layout-container">
              <SubmitHeader
                name={t(CONSTANTS.MODULE_INSTRUMENTTYPE)}
                link="manageinstrument/instrumenttype"
                isEdit={this.state.isEditMode}
                onSaveClick={this.onSaveClick}
                onCreateClick={this.onCreateClick}
                onCancelClick={this.onCancelClick}
                isLoading={this.state.formLoading}
              />
              <div className=" mt-3">
                <div className="col-md-12 no-padding">
                  <div className="box">
                    <div className="box-circle">
                      <p className="box-circle-text"> 1 </p>
                    </div>
                    <div className="ml-4">
                      <p className="sidebar-main-title font-weight-bold ml-2">
                        {t(CONSTANTS.LABLE_INSTRUMENT_TYPE) +
                          " " +
                          t(CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)}
                      </p>
                    </div>
                    <hr className="hr-line" />

                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          inputAttributes={{ autoFocus: "true" }}
                          dataType="text"
                          placeholder={t(CONSTANTS.LABLE_NAME)}
                          label={t(CONSTANTS.LABLE_NAME)}
                          required={true}
                          className={
                            this.state.nameError
                              ? "error-code mt-2 w-25"
                              : "mt-2 w-25"
                          }
                          value={this.state.name}
                          onValueChange={this.setName}
                          maxLength={250}
                          showValidationBarWhenInvalid={
                            this.state.nameError ? true : false
                          }
                          description={
                            this.state.nameError
                              ? this.state.name.length
                                ? t(CONSTANTS.NAME_VALIDATION_ERROR)
                                : t(CONSTANTS.FIELD_EMPTY_ERROR)
                              : ""
                          }
                        />
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col-sm col-md">
                        <Input
                          dataType="textarea"
                          label={t(CONSTANTS.LABEL_DESCRIPTION)}
                          placeholder={t(CONSTANTS.LABEL_DESCRIPTION)}
                          value={this.state.description}
                          onValueChange={this.setDescription}
                          inputAttributes={{ rows: "4" }}
                          className="mt-2 w-50"
                          resizable={false}
                          maxLength={200}
                        />
                      </div>
                    </div>
                    <div className="p-3">
                      {200 - this.state.description?.length}{" "}
                      {t("character left out of 200 character")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-2 mb-4">
                <AbbTableComponent
                authKey={CONSTANTS.AUTHKEY_INSTRUMENT_TYPE}
                  columns={[
                    {
                      dataField: "name",
                      text: t(CONSTANTS.MODULE_PROPERTY),
                      headerStyle: (colum, colIndex) => {
                        return { width: "15%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "customId",
                      text: t(CONSTANTS.LABLE_ID),
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "unit",
                      text: t(CONSTANTS.LABEL_UNIT),
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "description",
                      text: t(CONSTANTS.LABEL_DESCRIPTION),
                      headerStyle: (colum, colIndex) => {
                        return { width: "35%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "decimal",
                      text: t(CONSTANTS.LABEL_DECIMALS),
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      dataField: "type",
                      text: t(CONSTANTS.TYPE),
                      headerStyle: (colum, colIndex) => {
                        return { width: "10%", textAlign: "left" };
                      },
                    },
                    {
                      // TODO:Future changes
                      dataField: "delete",
                      text: "",
                    },
                  ]}
                  list={this.state.properties}
                  select={false}
                  isFixedColumn={false}
                  isEditable={false}
                  delete={false}
                  isAssociation={true}
                  associationAction={this.associationAction}
                  cellDelete={this.deleteProperty}
                  associationText="Associate Property"
                  isTitle={
                    <div className="float-left">
                      <div className="box-circle">
                        <p className="box-circle-text"> 2 </p>
                      </div>
                      <div className="ml-4">
                        <p className="sidebar-main-title font-weight-bold ml-2">
                          {t(CONSTANTS.LABEL_PROPERTIES)}
                        </p>
                      </div>
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(Form);
